import React from 'react';

/**
 * Renderiza el bloque OverviewRanking de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function OverviewRanking({
  v
}) {
  return React.createElement("section", {
    style: {
      "position": "relative",
      "zIndex": "30",
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.111111vh 1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "flex": v.alEmpty ? "1" : "0 1 auto",
      "minHeight": "0",
      "maxHeight": v.alEmpty ? "none" : "42%"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "marginBottom": "0.37037vh"
    }
  }, v.text("\n          "), React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.296296vh",
      "fontWeight": "600"
    }
  }, v.text("Jaulas · período completo")), v.text("\n          \n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": v.rankingColumns || "1.041667vw 2.916667vw repeat(4,minmax(0,1fr))",
      "gap": "1.111111vh",
      "padding": "0.37037vh 0.555556vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.12)",
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em",
      "alignItems": "center"
    }
  }, v.text("\n          "), React.createElement("span", {
    "onClick": v.rkAll.onClick,
    "title": v.rkAll.title,
    style: {
      "width": "0.729167vw",
      "height": "1.296296vh",
      "borderRadius": "0.277778vh",
      "border": "0.138889vh solid " + v.rkAll.bd,
      "background": v.rkAll.bg,
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "color": "#0a1424",
      "font": "700 0.925926vh sans-serif",
      "cursor": "pointer",
      "boxSizing": "border-box",
      "textTransform": "none"
    }
  }, v.text(v.rkAll.tick)), React.createElement("span", {
    "onClick": v.rkName.onClick,
    style: {
      "cursor": "pointer",
      "whiteSpace": "nowrap",
      "color": v.rkName.color,
      "fontWeight": v.rkName.fw
    }
  }, v.text(v.rkName.label + v.rkName.arrow)), v.text("\n          "), (v.rkCols || []).map((c, index6) => React.createElement(React.Fragment, {
    key: index6
  }, v.text("\n            "), React.createElement("span", {
    "onClick": c.onClick,
    style: {
      "cursor": "pointer",
      "textAlign": "right",
      "whiteSpace": "nowrap",
      "color": c.color,
      "fontWeight": c.fw
    }
  }, v.text(c.label + c.arrow)), v.text("\n          "))), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    "onScroll": v.rkScroll,
    style: {
      "flex": "1 1 auto",
      "minHeight": "0",
      "overflowY": "auto",
      "scrollbarWidth": "thin"
    }
  }, (v.rkRows || []).map((r, index7) => React.createElement(React.Fragment, {
    key: index7
  }, v.text("\n          "), React.createElement("div", {
    "onClick": r.onClick,
    "onMouseEnter": r.enter,
    "onMouseLeave": r.leave,
    style: {
      "display": "grid",
      "gridTemplateColumns": v.rankingColumns || "1.041667vw 2.916667vw repeat(4,minmax(0,1fr))",
      "gap": "1.111111vh",
      "alignItems": "center",
      "padding": "0.37037vh 0.555556vh",
      "borderRadius": "0.462963vh",
      "cursor": "pointer",
      "background": r.bg,
      "boxShadow": r.edge
    },
    className: "scapp-full-hover"
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "calc(100% + 0.416667vw)",
      "top": r.tipTop,
      "transform": r.tipTx,
      "width": "22.916667vw",
      "background": "rgba(4,10,20,0.96)",
      "border": "0.092593vh solid #2a3446",
      "borderRadius": "0.740741vh",
      "padding": "1.111111vh 1.296296vh",
      "display": r.tipD,
      "flexDirection": "column",
      "gap": "0.555556vh",
      "zIndex": "20",
      "cursor": "default",
      "boxShadow": "0 0.925926vh 2.777778vh rgba(0,0,0,0.6)"
    },
    "onClick": v.stopProp
  }, v.text("\n              "), React.createElement("div", {
    style: {
      "position": "absolute",
      "right": "100%",
      "top": "0",
      "bottom": "0",
      "width": "1.25vw"
    }
  }, null), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "center",
      "gap": "0.740741vh",
      "flexWrap": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.388889vh",
      "fontWeight": "600",
      "flex": "none"
    }
  }, v.text(r.name)), v.text("\n                "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.rkRanges || []).map((m, index8) => React.createElement(React.Fragment, {
    key: index8
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.185185vh 0.740741vh",
      "font": "1.018519vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "whiteSpace": "nowrap",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label)))))), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {}, v.text(r.tRange)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(r.tHov))), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "1.458333vw minmax(0,1fr) 1.770833vw",
      "gap": "0.555556vh"
    }
  }, v.text("\n                "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "space-between",
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "0.925926vh",
      "color": "oklch(0.72 0.17 25)",
      "textAlign": "right",
      "height": "11.111111vh"
    }
  }, React.createElement("span", {}, v.text(r.tAlMax)), React.createElement("span", {}, v.text("0"))), v.text("\n                "), React.createElement("div", {
    "onMouseMove": r.chMove,
    "onMouseLeave": r.chLeave,
    style: {
      "position": "relative",
      "height": "11.111111vh",
      "borderLeft": "0.052083vw solid oklch(0.72 0.17 25)",
      "borderBottom": "0.092593vh solid #2a3446",
      "borderRight": "0.052083vw solid oklch(0.68 0.2 25)",
      "cursor": "crosshair"
    }
  }, v.text("\n                  "), React.createElement("svg", {
    "viewBox": r.tVB,
    "preserveAspectRatio": "none",
    style: {
      "position": "absolute",
      "inset": "0",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "overflow": "visible"
    }
  }, v.text("\n                    "), React.createElement("path", {
    "d": r.tHovBar,
    "fill": "rgba(228,233,240,0.10)"
  }, null), v.text("\n                    "), React.createElement("path", {
    "d": r.tBars,
    "fill": "oklch(0.72 0.17 25)"
  }, null), v.text("\n                    "), React.createElement("path", {
    "d": r.tAyBars,
    "fill": "oklch(0.72 0.12 300)",
    "opacity": "0.45"
  }, null), v.text("\n                    "), React.createElement("path", {
    "d": r.tCum,
    "stroke": "oklch(0.68 0.2 25)",
    "strokeWidth": "2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke",
    "strokeLinejoin": "round"
  }, null), v.text("\n                  ")), v.text("\n                ")), v.text("\n                "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "space-between",
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "0.925926vh",
      "color": "oklch(0.68 0.2 25)",
      "height": "11.111111vh"
    }
  }, React.createElement("span", {}, v.text(r.tCumMax)), React.createElement("span", {}, v.text("0"))), v.text("\n              ")), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "1.458333vw minmax(0,1fr) 1.770833vw",
      "gap": "0.555556vh",
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "0.925926vh",
      "color": "#5a667a"
    }
  }, React.createElement("span", {}, null), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between"
    }
  }, React.createElement("span", {}, v.text(r.tX0)), React.createElement("span", {}, v.text(r.tX1))), React.createElement("span", {}, null)), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "1.296296vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "marginBottom": "0.37037vh"
    }
  }, v.text("\n                "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.925926vh",
      "background": "oklch(0.72 0.17 25)"
    }
  }, null), v.text("Alarmas / día")), v.text("\n                "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.185185vh",
      "background": "oklch(0.68 0.2 25)"
    }
  }, null), v.text("PPA acumulado")), v.text("\n                "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.925926vh",
      "background": "oklch(0.72 0.12 300)",
      "opacity": "0.6"
    }
  }, null), v.text("Ayuno")), v.text("\n              ")), v.text("\n              "), React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, v.text(r.tNote)), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "10ch 8ch 8ch 8ch 8ch",
      "gap": "1.041667vw",
      "justifyContent": "start",
      "minWidth": "0",
      "width": "100%",
      "padding": "0.37037vh 0",
      "borderBottom": "0.092593vh solid #2a3446",
      "fontSize": "1.111111vh",
      "fontWeight": "600"
    }
  }, v.text("\n                "), React.createElement("span", {
    style: {
      "color": "#e4e9f0"
    }
  }, v.text("Fecha")), React.createElement("span", {
    style: {
      "color": "oklch(0.72 0.17 25)",
      "textAlign": "right"
    }
  }, v.text("Alarmas")), React.createElement("span", {
    style: {
      "color": "oklch(0.72 0.12 300)",
      "textAlign": "right"
    }
  }, v.text("Ayunos")), React.createElement("span", {
    style: {
      "color": "oklch(0.8 0.13 85)",
      "textAlign": "right"
    }
  }, v.text("PPA")), React.createElement("span", {
    style: {
      "color": "#a8d5a2",
      "textAlign": "right"
    }
  }, v.text("Score")), v.text("\n              ")), v.text("\n              "), React.createElement("div", {
    "data-rk-scroll": "1",
    style: {
      "position": "relative",
      "maxHeight": "17.592593vh",
      "overflowY": "auto",
      "overflowX": "hidden",
      "display": "flex",
      "flexDirection": "column",
      "paddingRight": "0.208333vw"
    }
  }, (r.tDays || []).map((d, index9) => React.createElement(React.Fragment, {
    key: index9
  }, v.text("\n                "), React.createElement("div", {
    "data-rk-day": d.key,
    style: {
      "display": "grid",
      "gridTemplateColumns": "10ch 8ch 8ch 8ch 8ch",
      "gap": "1.041667vw",
      "justifyContent": "start",
      "minWidth": "0",
      "width": "100%",
      "padding": "0.277778vh 0",
      "borderBottom": "0.092593vh solid #151e2c",
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.111111vh",
      "background": d.bg
    }
  }, v.text("\n                  "), React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "fontWeight": d.fw
    }
  }, v.text(d.date)), v.text("\n                  "), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": d.alC
    }
  }, v.text(d.al)), v.text("\n                  "), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": d.ayC
    }
  }, v.text(d.ay)), v.text("\n                  "), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": d.ppC
    }
  }, v.text(d.ppa)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": d.scoreC
    }
  }, v.text(d.score)), v.text("\n                ")), v.text("\n              ")))), v.text("\n              "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "10ch 8ch 8ch 8ch 8ch",
      "gap": "1.041667vw",
      "justifyContent": "start",
      "minWidth": "0",
      "width": "100%",
      "padding": "0.462963vh 0 0",
      "fontFamily": "'IBM Plex Mono',monospace",
      "fontSize": "1.111111vh",
      "fontWeight": "600"
    }
  }, v.text("\n                "), React.createElement("span", {
    style: {
      "color": "#e4e9f0",
      "fontFamily": "'IBM Plex Sans',sans-serif"
    }
  }, v.text("Total")), v.text("\n                "), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": "oklch(0.72 0.17 25)"
    }
  }, v.text(r.tAl)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": "oklch(0.72 0.12 300)"
    }
  }, v.text(r.tAy)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": "oklch(0.8 0.13 85)"
    }
  }, v.text(r.tPpa)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": r.scC
    }
  }, v.text(r.tScore)), v.text("\n              ")), v.text("\n            ")), v.text("\n            "), React.createElement("span", {
    "onClick": r.onCmp,
    style: {
      "width": "0.729167vw",
      "height": "1.296296vh",
      "borderRadius": "0.277778vh",
      "border": "0.138889vh solid " + r.cBox,
      "background": r.cFill,
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "fontSize": "0.925926vh",
      "color": "#0a0f18",
      "fontWeight": "700"
    }
  }, v.text(r.cCheck)), v.text("\n            "), React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "fontWeight": r.fw
    }
  }, v.text(r.name)), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "500 1.203704vh 'IBM Plex Mono',monospace",
      "textAlign": "right"
    }
  }, v.text(r.al)), React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "background": "#1c2636",
      "borderRadius": "0.185185vh",
      "display": "flex"
    }
  }, React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "width": r.alW,
      "background": "oklch(0.72 0.17 25)"
    }
  }, null))), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "500 1.203704vh 'IBM Plex Mono',monospace",
      "textAlign": "right"
    }
  }, v.text(r.ay)), React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "background": "#1c2636",
      "borderRadius": "0.185185vh",
      "display": "flex"
    }
  }, React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "width": r.ayW,
      "background": "oklch(0.72 0.12 300)"
    }
  }, null))), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "500 1.203704vh 'IBM Plex Mono',monospace",
      "textAlign": "right"
    }
  }, v.text(r.ppa)), React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "background": "#1c2636",
      "borderRadius": "0.185185vh",
      "display": "flex"
    }
  }, React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "width": r.ppaW,
      "background": "oklch(0.8 0.13 85)"
    }
  }, null))), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "500 1.203704vh 'IBM Plex Mono',monospace",
      "textAlign": "right",
      "color": r.scC
    }
  }, v.text(r.sc)), React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "background": "#1c2636",
      "borderRadius": "0.185185vh",
      "display": "flex"
    }
  }, React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "width": r.scW,
      "background": r.scC
    }
  }, null))), v.text("\n          ")), v.text("\n        ")))), v.text("\n      "));
}
